export const salaryFrequencyList = [
    {
        id: '1',
        title: 'Per year',
    },
    {
        id: '2',
        title: 'Per month',
    },
    {
        id: '3',
        title: 'Per hour',
    },
];

export const workplaceTypeList = [
    {
        id: '1',
        title: 'On site',
    },
    {
        id: '2',
        title: 'Hybrid',
    },
    {
        id: '3',
        title: 'Remote',
    },
];

export const jobTypeList = [
    {
        id: '1',
        title: 'Full time',
    },
    {
        id: '2',
        title: 'Part time',
    },
    {
        id: '3',
        title: 'Contract',
    },
    {
        id: '4',
        title: 'Temporary',
    },
    {
        id: '5',
        title: 'Other',
    },
    {
        id: '6',
        title: 'Volunteer',
    },
    {
        id: '7',
        title: 'Internship',
    },
];

export const codingLanguagesList = [
    {
        id: 'c',
        title: 'C'
    },
    {
        id: 'cpp',
        title: 'C++'
    },
    {
        id: 'csharp',
        title: 'C#'
    },
    {
        id: 'rust',
        title: 'Rust'
    },
    {
        id: 'java',
        title: 'Java'
    },
    {
        id: 'r',
        title: 'R'
    },
    {
        id: 'go',
        title: 'Go'
    },
    {
        id: 'python',
        title: 'Python'
    },
    {
        id: 'javascript',
        title: 'Java Script'
    },
    {
        id: 'typescript',
        title: 'Type Script'
    },
    {
        id: 'swift',
        title: 'Swift'
    },
    {
        id: 'php',
        title: 'PHP'
    },
    {
        id: 'scala',
        title: 'Scala'
    },
    {
        id: 'kotlin',
        title: 'Kotlin'
    },
    {
        id: 'ruby',
        title: 'Ruby'
    },
]
// english is always included as the default exam language and can not be removed
export const defaultExamTranslateLanguage = { id: 'EN', title: 'English' };

export const examTranslateLanguagesList = [
    // Major European languages
    { id: 'FR', title: 'French' },
    { id: 'DE', title: 'German' },
    { id: 'ES', title: 'Spanish' },
    { id: 'IT', title: 'Italian' },
    { id: 'PT', title: 'Portuguese' },
    { id: 'NL', title: 'Dutch' },
    { id: 'PL', title: 'Polish' },
    { id: 'RU', title: 'Russian' },
    { id: 'UK', title: 'Ukrainian' },
    { id: 'BE', title: 'Belarusian' },
    { id: 'CS', title: 'Czech' },
    { id: 'SK', title: 'Slovak' },
    { id: 'SL', title: 'Slovenian' },
    { id: 'HR', title: 'Croatian' },
    { id: 'BS', title: 'Bosnian' },
    { id: 'SR', title: 'Serbian' },
    { id: 'BG', title: 'Bulgarian' },
    { id: 'MK', title: 'Macedonian' },
    { id: 'SQ', title: 'Albanian' },
    { id: 'EL', title: 'Greek' },
    { id: 'RO', title: 'Romanian' },
    { id: 'HU', title: 'Hungarian' },
    { id: 'SV', title: 'Swedish' },
    { id: 'NO', title: 'Norwegian' },
    { id: 'DA', title: 'Danish' },
    { id: 'FI', title: 'Finnish' },
    { id: 'IS', title: 'Icelandic' },
    { id: 'ET', title: 'Estonian' },
    { id: 'LV', title: 'Latvian' },
    { id: 'LT', title: 'Lithuanian' },
    { id: 'GA', title: 'Irish' },
    { id: 'CY', title: 'Welsh' },
    { id: 'MT', title: 'Maltese' },
    { id: 'LB', title: 'Luxembourgish' },
    { id: 'CA', title: 'Catalan' },
    { id: 'EU', title: 'Basque' },
    { id: 'GL', title: 'Galician' },
    { id: 'OC', title: 'Occitan' },
    { id: 'CO', title: 'Corsican' },
    { id: 'SC', title: 'Sardinian' },
    { id: 'AST', title: 'Asturian' },
    { id: 'FO', title: 'Faroese' },
    { id: 'FY', title: 'Western Frisian' },
    { id: 'SE', title: 'Northern Sami' },
    { id: 'YI', title: 'Yiddish' },
    { id: 'HY', title: 'Armenian' },
    { id: 'KA', title: 'Georgian' },
    { id: 'AZ', title: 'Azerbaijani' },
    { id: 'TR', title: 'Turkish' },

    // Asian languages
    { id: 'AR', title: 'Arabic' },
    { id: 'FA', title: 'Persian' },
    { id: 'HI', title: 'Hindi' },
    { id: 'ZH', title: 'Chinese' },
    { id: 'JA', title: 'Japanese' },
    { id: 'KO', title: 'Korean' },
    { id: 'TH', title: 'Thai' },
    { id: 'VI', title: 'Vietnamese' },
    { id: 'ID', title: 'Indonesian' },
    { id: 'MS', title: 'Malay' },
    { id: 'TL', title: 'Filipino' },
    { id: 'TA', title: 'Tamil' },
    { id: 'TE', title: 'Telugu' },
    { id: 'BN', title: 'Bengali' },
    { id: 'UR', title: 'Urdu' },
    { id: 'PA', title: 'Punjabi' },
    { id: 'GU', title: 'Gujarati' },
    { id: 'MR', title: 'Marathi' },
    { id: 'NE', title: 'Nepali' },
    { id: 'SI', title: 'Sinhala' },
    { id: 'KM', title: 'Khmer' },
    { id: 'LO', title: 'Lao' },
    { id: 'MY', title: 'Burmese' },
    { id: 'MN', title: 'Mongolian' },
    { id: 'KK', title: 'Kazakh' },
    { id: 'UZ', title: 'Uzbek' },
    { id: 'KY', title: 'Kyrgyz' },
    { id: 'TG', title: 'Tajik' },

    // Singapore
    { id: 'SG', title: 'Singaporean English' },

    // Additional languages
    { id: 'HE', title: 'Hebrew' },
    { id: 'SW', title: 'Swahili' },
    { id: 'AF', title: 'Afrikaans' },
    { id: 'AM', title: 'Amharic' },
    { id: 'HA', title: 'Hausa' },
    { id: 'YO', title: 'Yoruba' },
    { id: 'IG', title: 'Igbo' },
];
